<template>
  <div v-if="movie && showTime" class="flex flex-col lg:flex-row justify-center lg:gap-6">
    <div class="lg:w-8/12" v-if="showTime.non_allocated_seating===0">
    
      <ul class="bg-white flex flex-col text-left lg:hidden">
        <li class="p-6 w-full flex flex-col gap-3">
          <h2 class="text-2xl leading-none">{{movie.movie_name}}</h2>
          <div class="flex flex-row gap-3">
            {{formatDate(showTime.show_time)}}
            <div v-if="showTime.non_allocated_seating===1">Onumrerat / fri sittning</div>
          </div>
          <div>Slutför bokning inom: {{ new Date(timerCount * 1000).toISOString().slice(14, 19) }}</div>
        </li>
      </ul>
      
      <div class="cut dashed bg-white lg:hidden"></div>
      
      <div class="bg-white flex flex-col p-6">
        
        <h2 class="text-2xl mb-3">1. Välj plats</h2>
        
        <div class="text-sm text-center w-full opacity-50">
          Filmduk
        </div>
        <div id="seatmap">
          <div
            v-for="seat in seats"
            class="seat flex justify-center items-center"
            :class="{
              manager: [ 4 ].includes(seat.seat_type),
              aisle: [ 0 ].includes(seat.seat_type),
              chair: [ 1, 2, 4, 5, 6, 10, 7, 8, 9 ].includes(seat.seat_type),
              active: [ 1, 2, 5, 6, 10, 7, 8, 9 ].includes(seat.seat_type),
              wheelchair: [ 2 ].includes(seat.seat_type),
              broken: [ 3, 60 ].includes(seat.seat_type),
              table: [ 97, 98 ].includes(seat.seat_type),
              exit: [ 70, 71, 72, 73, 80, 81, 82, 83 ].includes(seat.seat_type),
              bookable: [ 0, 1 ].includes(seat.seat_status),
              locked: seat.mobile_device_id === mobile_device_id && 1 === seat.seat_status,
            }"
            :key="seat.cinema_seatplan_id"
            :style="{
              top: seat.position_top/400*100 + '%', 
              left: seat.position_left/800*100 + '%', 
              width: seat.width/400*50 + '%', 
              height: seat.height/400*100 + '%'
            }"
            @click="toggleSeat(seat)"
          >
            
            <svg v-if="[ 70, 71, 72, 73, 80, 81, 82, 83 ].includes(seat.seat_type)" fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
             width="800px" height="800px" viewBox="0 0 492.5 492.5" xml:space="preserve"
            ><g><path d="M184.646,0v21.72H99.704v433.358h31.403V53.123h53.539V492.5l208.15-37.422v-61.235V37.5L184.646,0z M222.938,263.129
              c-6.997,0-12.67-7.381-12.67-16.486c0-9.104,5.673-16.485,12.67-16.485s12.67,7.381,12.67,16.485
              C235.608,255.748,229.935,263.129,222.938,263.129z"/></g></svg>

            <svg v-if="[ 2 ].includes(seat.seat_type)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM120.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464C98.1 464 48 413.9 48 352c0-47.9 30.1-88.8 72.5-104.8zM259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h5.1c.4 0 .8 0 1.3 0h94.1c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H282.2l-9.6-48H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H259.8z"/></svg>
            
            <svg v-if="seat.mobile_device_id === mobile_device_id && 1 === seat.seat_status" height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 17.837 17.837" xml:space="preserve"><g><path style="fill:#030104;" d="M16.145,2.571c-0.272-0.273-0.718-0.273-0.99,0L6.92,10.804l-4.241-4.27c-0.272-0.274-0.715-0.274-0.989,0L0.204,8.019c-0.272,0.271-0.272,0.717,0,0.99l6.217,6.258c0.272,0.271,0.715,0.271,0.99,0L17.63,5.047c0.276-0.273,0.276-0.72,0-0.994L16.145,2.571z"/></g></svg>

          </div>
          <div v-if="clientSecret||loading" class="bg-white opacity-90 absolute top-0 bottom-0 left-8 right-8"></div>
        </div>
        <div class="my-6">
          <ul class="text-xs md:text-sm flex flex-row justify-center flex-wrap gap-x-3 gap-y-1">
            <li class="flex items-center gap-2">
              <div class="h-4 w-4 rounded-full ibookable"></div>
              Tillgängliga stol
            </li>
            <li class="flex items-center gap-2">
              <div class="h-4 w-4 rounded-full ilocked"></div>
              Vald stol
            </li>
            <li class="flex items-center gap-2">
              <div class="h-4 w-4 rounded-full imanager"></div>
              Ej biostol
            </li>
            <li class="flex items-center gap-2">
              <div class="h-4 w-4 rounded-full iwheelchair"></div>
              Rullstolsplats
            </li>
            <li class="flex items-center gap-2">
              <div class="h-4 w-4 rounded-full ibooked"></div>
              Ej tillgänglig
            </li>
            <li class="flex items-center gap-2">
              <div class="h-4 w-4 itable"></div>
              Bord
            </li>
            <li class="flex items-center gap-2">
              <div class="h-4 w-4 iexit"></div>
              Ingång / Utgång
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="text-sm bg-white lg:w-4/12">
        
        <div class="cut dashed bg-white lg:hidden"></div>
        
        <div v-if="!clientSecret" class="p-6 flex flex-col">
          
          <h2 class="text-2xl mb-3">2. Välj biljettyp</h2>
          
          <div v-if="showTime.non_allocated_seating===1">
            <button @click="lockSeat()" class=" flex items-center gap-1 underline hover:no-underline">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
                <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z" clip-rule="evenodd" />
              </svg>
              Lägg till biljett
            </button>
          </div>
          
          <ul v-if="tickets.length>0" class="bg-white grid grid-cols-1 divide-y -my-3">
            <li class="list-none flex flex-col gap-2 text-sm py-3" v-for="ticket in tickets" :key="ticket.cinema_seatplan_id">
              <div class="flex flex-row justify-between">
                <h3 class="text-lg" v-if="showTime.non_allocated_seating===0">Rad {{ticket.row_name}}, stol {{ticket.seat_name}}</h3>
                <h3 class="text-lg" v-if="showTime.non_allocated_seating===1">Biljett onumrerad</h3>
                <button @click="toggleSeat(ticket)" class="text-xs">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM6.75 9.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z" clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
              
              <div class="flex flex-col gap-3" v-if="ticket.ticket_types">
                <div
                  v-for="type in ticket.ticket_types"
                  :key="type.ticket_id"
                  class="flex flex-col justify-start"
                >
                  <div class="flex flex-row items-start gap-3">
                    <input type="radio" class="my-1" v-model="ticket.selected" :name="ticket.cinema_seatplan_id+''+type.ticket_id" :id="ticket.cinema_seatplan_id+''+type.ticket_id" :value="type">
                    <label class="text-sm cursor-pointer hover:underline" :for="ticket.cinema_seatplan_id+''+type.ticket_id">
                      {{type.ticket_name_display}} - {{type.display_price}} kr
                    </label>
                    <button v-if="!type.show_note" @click="type.show_note=true">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5"><path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 0 1-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 0 1-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584ZM12 18a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd" /></svg>
                    </button>
                  </div>
                  <div v-if="type.show_note" class="opacity-75 my-1">{{type.note}}</div>
                </div>
              </div>
            </li>
          </ul>
        
        <div class="flex flex-col mb-2" v-if="tickets.length===0">
          <span class="text-left opacity-50">Inga stolar valda.</span>
        </div>
      </div>
      <div v-if="tickets.length!==0"> 
        
        <div class="cut dashed bg-white"></div>
        
        <div class="bg-white p-6"> 
          
          <h2 class="text-2xl mb-3">3. Gör tillval</h2>
          
          <div class="flex flex-col gap-4">
            <ul class="text-left flex flex-col gap-2" v-if="toLateForFood(showTime.show_time)">
              <li class="opacity-50">
                Du kan inte längre förbeställa mat inför den här föreställningen. Du är välkommen att köpa mat på plats i vår bistro.
              </li>
            </ul>
            <ul class="text-left flex flex-col gap-2  divide-y -my-3" v-if="!toLateForFood(showTime.show_time)">
              <li v-for="product in products" :key="product.product_id" class="flex flex-row items-start justify-between py-3">
                <div class="flex flex-col">
                  <strong class="font-bold">{{product.product_name}} - {{product.display_price}} kr</strong>
                  <span class="text-sm">{{product.descriptions.SV.description}}</span>
                </div>
                <div class="flex flex-row gap-1 items-center text-base">
                  <button class="w-6 h-6 flex justify-center items-center cursor-pointer" @click="removeFromOrder(product)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM6.75 9.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z" clip-rule="evenodd" />
                    </svg>
                  </button>
                  <span>{{(product.amount||0)}}</span>
                  <button class="w-6 h-6 flex justify-center items-center cursor-pointer" @click="addToOrder(product)" >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.75-11.25a.75.75 0 0 0-1.5 0v2.5h-2.5a.75.75 0 0 0 0 1.5h2.5v2.5a.75.75 0 0 0 1.5 0v-2.5h2.5a.75.75 0 0 0 0-1.5h-2.5v-2.5Z" clip-rule="evenodd" />
                    </svg>
                  </button>
                </div>
              </li>
            </ul>
            
            <div class="flex flex-row justify-between items-center font-bold">
              <div>Summa:</div>
              <div>{{order.amount}} kr</div>
            </div>
          </div>
        </div>
      </div>
          
        <div v-if="tickets.length!==0">  
          <div class="cut dashed bg-white"></div>
         <div class="bg-white p-6">
           <div class="flex flex-col gap-3">
             
             <h2 class="text-2xl mb-3">4. Betala</h2>
            
            <div class="flex flex-col gap-2">
              <input class="py-1 px-2 border text-sm" v-model="email" type="email" placeholder="Din e-postadress" />
              
              <input class="py-1 px-2 border text-sm" v-model="postcode" type="text" placeholder="Postkod" />
              
              <label class="flex items-center gap-2 text-sm">
                <input type="checkbox" v-model="newsmail" value="1" name="newsmail" id="newsmail">
                <span>Jag vill ha Aspens nyhetsbrev.</span>
              </label>
            </div>
            
            <button @click="loadClientSecret" class="bg-black text-white p-3 px-6">Till betalning</button>
            
            <div class="text-sm opacity-70">
              <p v-if="activeProducts.length > 0">Du hämtar din mat i Aspens kassa mot uppvisande av kvitto</p>
              <p> Du får dina biljetter till den e-postadress du angivit i samband med köpet. Får du inte dina biljetter så ta kontakt med oss så löser vi det. Genom att genomföra bokning godkänner du våra <a class="underline hover:no-underline text-black" href="/kopvillkor/" target="_blank">köpvillkor</a>.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="" v-if="clientSecret">
        <div class="cut dashed p-6 bg-white text-sm">
          <h3 class="text-lg">Din bokning</h3>
          <ul class="flex flex-col gap-2 pt-3">
            <li v-for="ticket in order.order.tickets" :key="ticket.ticket_id" class="flex flex-row justify-between">
              <span>{{ticket.selected.ticket_name}}</span>
              <span>{{ticket.selected.display_price}} kr</span>
            </li>
            <li v-for="product in activeProducts" :key="product.product_id" class="flex flex-row justify-between">
              <span>{{product.amount}} st. {{product.product_name}}</span>
              <span>{{(product.amount*product.display_price)}} kr</span>
            </li>
            <li class="pt-3 flex flex-row justify-between font-bold">
              <span>Summa</span>
              <span>{{order.amount}} kr</span>
            </li>
          </ul>
        </div>
        <div class="cut dashed p-6 bg-white text-sm">
          <form class="flex flex-col gap-6">
            <PaymentModule :client-secret="clientSecret" :amount="order.amount" :order="order" :email="email"  />
            <button @click="clientSecret=false" class="bg-text text-black">Avbryt</button>
          </form>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import PaymentModule from './PaymentModule.vue'

export default {
  name: 'SeatPlan',
  components: {
    PaymentModule
  },
  data() {
    return {
      showTimeId: window.showTimeId,
      movieId: window.movieId,
      movie_time: window.movieTime,
      myOrder: [],
      tickets: [],
      email: "",
      postcode: "",
      newsmail: "",
      seats: [],
      products: [],
      lockedSeats: [],
      clientSecret: false,
      movie: null,
      showTime: null,
      timerCount: 600,
      loading: false,
    };
  },
  setup() {
    let mobile_device_id = localStorage.getItem('mobile_device_id');
    if (!mobile_device_id) {
      mobile_device_id = crypto.randomUUID();
      localStorage.setItem('mobile_device_id', mobile_device_id);
    }
    return {
      mobile_device_id
    }
  },
  computed: {
    activeProducts: function () {
      return this.order.order.products.filter(i => i.amount > 0)
    },
    order: function () {
      let amount = 0
      this.tickets.forEach( (ticket) => {
        amount = amount + ticket.selected.product_price
      })
      this.products.forEach( (product) => {
        amount = amount + product.product_price*(product.amount||0)
      })
      return {
        amount: amount,
        show_time_id: this.showTimeId,
        show_time: this.movie_time,
        order: {
          email: this.email,
          postcode: this.postcode,
          newsmail: this.newsmail,
          tickets: this.tickets,
          products: this.products
        }
      }
    },
    locked: function () {
      return this.seats.filter(i => ( i.mobile_device_id === this.mobile_device_id && i.seat_status === 0 && i.discount_code_required !== true) )
    }
  },
  watch: {
    seats: function() {
      this.clientSecret = false
      this.syncTickets()
    },
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--
          }, 1000)
        } else {
          this.tickets.forEach( (seat) => {
            this.toggleSeat(seat)
          } )
          alert( 'Din bokning tog för lång tid. Var god försök igen.' )
          this.timerCount = 600
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    }
  },
  methods: {
    toLateForFood: function (dateString) {
      let today = new Date(Date.now() + 4 * (60 * 60 * 1000) );
      return new Date(dateString) < today;
    },
    formatDate( dateString ){
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('sv', {
         month: 'long',
         day: 'numeric',
         hour: 'numeric',
         minute: 'numeric',
         hour12: false
      }).format(date);
    },
    addToOrder(product){
      product.amount = (product.amount||0)+1;
    },
    removeFromOrder(product){
      product.amount = Math.max(0,(product.amount||0)-1);
    },
    validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    syncTickets(){
      this.seats.forEach((ticket) => {
        const found = this.tickets.some(el => el.cinema_seatplan_id === ticket.cinema_seatplan_id)
        if(found && ticket.mobile_device_id !== this.mobile_device_id){
          this.removeTicket(ticket)
        }else if(!found && ticket.mobile_device_id === this.mobile_device_id && ticket.seat_status === 1){
          this.addTicket(ticket)
        }
      })
    },
    async addTicket(ticket){
      const response = await fetch('https://www.bioaspen.se/wp-json/bioaspen/v1/ticket-types?show_time_id=' + this.showTimeId + '&cinema_screen_section_id=' + ticket.cinema_screen_section_id + '&mobile_device_id=' + this.mobile_device_id);
      const ticket_types = await response.json();
      ticket.ticket_types = ticket_types.data;
      ticket.price = ticket.ticket_types[0].display_price; 
      ticket.selected = ticket.ticket_types[0];
      this.tickets.push(ticket);
    },
    async removeTicket(ticket){
      this.tickets = this.tickets.filter((aTicket) => aTicket.cinema_seatplan_id !== ticket.cinema_seatplan_id);
    },
    async loadClientSecret() {
      if ( ! this.validateEmail( this.email ) ) {
        alert( "Du måste ange en riktig epostadress." )
        return
      }
      this.clientSecret = false;
      const response = await fetch(
        'https://www.bioaspen.se/wp-json/bioaspen/v1/payment-intent',
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            order: this.order
          })
        }
      );
      const paymentIntent = await response.json();
      this.clientSecret = paymentIntent.client_secret;
    },
    async lockSeat( seat ) {
      let url = '';
      this.loading = true;
      if ( seat ) {
        url = 'https://www.bioaspen.se/wp-json/bioaspen/v1/lock-seat?show_time_id=' + this.showTimeId + '&cinema_seatplan_id=' + seat.cinema_seatplan_id + '&mobile_device_id=' + this.mobile_device_id;
      } else {
        url = 'https://www.bioaspen.se/wp-json/bioaspen/v1/lock-seat?show_time_id=' + this.showTimeId + '&mobile_device_id=' + this.mobile_device_id;
      }
      try {
        const response = await fetch( url );
        const seats = await response.json();
        this.seats = seats.data;
      } catch (error) {
        console.error(error);
      }
    },
    async toggleSeat( seat ) {
      if( [ 0, 1 ].includes( seat.seat_status ) && [ 1, 2, 4 ].includes( seat.seat_type ) ) {
        this.loading=true;
        if( this.mobile_device_id === seat.mobile_device_id){
          try {
            const response = await fetch('https://www.bioaspen.se/wp-json/bioaspen/v1/unlock-seat?show_time_id=' + this.showTimeId + '&seat_lock_id=' + seat.seat_lock_id + '&mobile_device_id=' + this.mobile_device_id);
            if(!response.ok){
              alert('Det gick inte att avboka platsen.');
              return;
            }
            const seats = await response.json();
            this.seats = seats.data;
          } catch (error) {
            console.error(error);
          }
        }else{
          try {
            const response = await fetch('https://www.bioaspen.se/wp-json/bioaspen/v1/lock-seat?show_time_id=' + this.showTimeId + '&cinema_seatplan_id=' + seat.cinema_seatplan_id + '&mobile_device_id=' + this.mobile_device_id);
            if(!response.ok){
              alert('Det gick inte att boka platsen.');
              return;
            }
            const seats = await response.json();
            this.seats = seats.data;
          } catch (error) {
            console.error(error);
          }
        }
        this.loading=false;
      }
    },
    async getProducts() {
      try {
        const response = await fetch('https://www.bioaspen.se/wp-json/bioaspen/v1/products?show_time_id=' + this.showTimeId + '&mobile_device_id=' + this.mobile_device_id);
        const products = await response.json();
        this.products = products.data.filter(i => ( i.product_category_name === 'Food online') );
      } catch (error) {
        console.error(error);
      }
    },
    async getMovie() {
      try {
        const response = await fetch('https://www.bioaspen.se/wp-json/bioaspen/v1/get-movie?movie_id=' + this.movieId + '&mobile_device_id=' + this.mobile_device_id);
        const movie = await response.json();
        this.movie = movie.data.shift();
      } catch (error) {
        console.error(error);
      }
    },
    async getShowTime() {
      try {
        const response = await fetch('https://www.bioaspen.se/wp-json/bioaspen/v1/get-showtime?show_time_id=' + this.showTimeId + '&mobile_device_id=' + this.mobile_device_id);
        const showTime = await response.json();
        this.showTime = showTime.data.shift();
      } catch (error) {
        console.error(error);
      }
    },
    async getSeatplan() {
      try {
        const response = await fetch('https://www.bioaspen.se/wp-json/bioaspen/v1/seats?show_time_id=' + this.showTimeId + '&mobile_device_id=' + this.mobile_device_id);
        const seats = await response.json();
        this.seats = seats.data;
      } catch (error) {
        console.error(error);
      }
    },
  },
  created() {
    this.getSeatplan();
    this.getMovie();
    this.getShowTime();
    this.getProducts();
  },
}
</script>
